// extracted by mini-css-extract-plugin
export var button = "_52-0";
export var icon = "_52-1";